<!--
作者：Loong
时间：2020/07/17
-->
<!-- UserInfoChange [ 业主信息修改 ] -->
<template>

    <div id='userInfoChange'>
        <div class="userInfoChangeBox">

            <div class="editInfoItem">
                <ul>
                    <li>
                        <span class="editInfoItem_label">户号</span>
                        <el-input v-model="dataset.account" placeholder="请输入户号" style="width: 300px;" :maxlength="12" disabled></el-input>
                    </li>
                    <li>
                        <span class="editInfoItem_label">业主类型</span>
                        <el-select v-model="dataset.nature" placeholder="请选择" style="width: 180px;">
                            <el-option v-for="item in natures" :key="item.num" :label="item.value" :value="item.num"></el-option>
                        </el-select>
                    </li>
                    <li>
                        <span class="editInfoItem_label">业主姓名</span>
                        <el-input v-model="dataset.owner_name" placeholder="请输入业主姓名" style="width: 200px;" ></el-input>
                    </li>
                    <li>
                        <span class="editInfoItem_label">业主手机</span>
                        <el-input v-model="dataset.owner_phone" placeholder="请输入业主手机" style="width: 200px;" :maxlength="11" ></el-input>
                    </li>
                    <li>
                        <span class="editInfoItem_label">小区名</span>
                        <el-input v-model="dataset.community_name" placeholder="请输入小区名" style="width: 200px;" disabled :maxlength="11" ></el-input>
                    </li>
                    <li>
                        <span class="editInfoItem_label">楼号</span>
                        <el-input v-model="dataset.buildnum" placeholder="请输入楼号" style="width: 200px;" :maxlength="11" ></el-input>
                    </li>
                    <li>
                        <span class="editInfoItem_label">单元号</span>
                        <el-input v-model="dataset.unitnum" placeholder="请输入单元号" style="width: 200px;" :maxlength="11" ></el-input>
                    </li>
                    <li>
                        <span class="editInfoItem_label">门牌号</span>
                        <el-input v-model="dataset.doornum" placeholder="请输入门牌号" style="width: 200px;" :maxlength="11" ></el-input>
                    </li>
                    <li>
                        <span class="editInfoItem_label">建筑面积</span>
                        <el-input v-model="dataset.floor_area" placeholder="请输入建筑面积" style="width: 200px;" :maxlength="11" disabled ></el-input>
                    </li>
                </ul>
            </div>

            <div class="editInfoItem">
                <el-button type="primary" style="width:120px; margin-left: 330px;" @click="onSubmit()">提交</el-button>
                <el-button style="width: 120px;margin-bottom: 20px; margin-left: 30px;" @click="$emit('onClose')">关闭</el-button>
            </div>

        </div>
    </div>

</template>

<script>
export default {
    components: { },

    props: ['loadData', 'natures'],

    data() {
        return{
            dataset: {},

            idKey: null,
        }
    },

    computed: { },

    watch: {
        route: {
            handler: function(val, old){

            },
            deep: true
        }
    },

    created(){

    },

    mounted(){
        this.loadMain();

        this.getData();
    },

    methods:{
        loadMain(){
            this.idKey = this.loadData.account;
        },

        getData(){
            this.$jssdk.account.detail({ account: this.loadData.account }, (r) =>{
                this.dataset = r;
            },(err) =>{
                this.$message({
                    type:'warning',
                    message:err.data,
                    duration:2000
                })
            });
        },

        onSubmit(){
            if(!this.dataset.nature){
                this.$message({ type:'warning',message:'请选择类型',duration:2000});
                return ;
            }
            if(!this.dataset.owner_name){
                this.$message({ type:'warning',message:'请输入业主姓名',duration:2000});
                return ;
            }
            if(!this.dataset.doornum){
                this.$message({ type:'warning',message:'请输入门牌号',duration:2000});
                return ;
            }
            this.$jssdk.account.edit({ 
                account: this.loadData.account,
                nature: this.dataset.nature,
                owner_name: this.dataset.owner_name,
                owner_phone: this.dataset.owner_phone,
                buildnum: this.dataset.buildnum,
                unitnum: this.dataset.unitnum,
                doornum: this.dataset.doornum
            }, (r) =>{
                this.$message({
                    message: r,
                    type: 'success',
                });
                this.$emit('onClose', []);
            },(err) =>{
                this.$message({
                    type:'warning',
                    message:err.msg,
                    duration:2000
                })
            });
        },
    },
}
</script>

<style lang='less'>

</style>

<style lang='less' scoped>
    #userInfoChange{
        position: absolute;
		top: 0;
        left: 0;
        right: 0;
        bottom: 0;
		z-index: 6;
        background-color: rgba(0,0,0,.7);
        
        .userInfoChangeBox{
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 900px;
            max-height: 90%;
            border:2px solid #8fceff;
            border-radius: 10px;
            box-shadow: 5px 10px 10px rgba(51,51,51,.3);
            background-color: #ffffff;
            overflow-y: auto;

            .editInfoItem_label{
                display: inline-block;
                width: 75px;
            }
            .editInfoItem ul{
                overflow:hidden;
                list-style: none;
                padding: 0;
                margin-left: 10px;
            }
            .editInfoItem ul li{
                float: left;
                font-size: 14px;
                margin: 20px 12px  7px  7px !important;
                
            }
            .editInfoItem ul li:nth-child(1){
                width: 400px;
            }
            .editInfoItem ul li:last-child{
                line-height: 50px;
                height: 50px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// UserInfoChange.vue?890f0454